"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAvatarConfig = validateAvatarConfig;
exports.normalizeAvatarConfig = normalizeAvatarConfig;
exports.nicknameFormatError = nicknameFormatError;
const items_1 = require("./items");
const options_1 = require("./options");
const NICKNAME_PATTERN = /^[A-Za-z0-9_]+$/;
const RESERVED_FRAGMENTS = ['admin', 'moderator', 'support', 'official', 'staff', 'designwithfriends', 'design_with_friends', 'dwf_team'];
/** A built-in option, or (for the traits items can go in) an item reference. Whether the item exists and is the user's is the server's check. */
const isAllowedValue = (trait, value) => typeof value === 'string'
    && (options_1.AVATAR_OPTIONS[trait].includes(value) || ((0, items_1.itemSlotOfTrait)(trait) !== null && (0, items_1.itemIdOf)(value) !== null));
/** Returns a copy holding only known traits with allowed values, or null when the input is not a valid avatar. */
function validateAvatarConfig(input) {
    if (!input || typeof input !== 'object')
        return null;
    const source = input;
    const rotation = source.backgroundRotation;
    if (typeof rotation !== 'number' || !Number.isFinite(rotation))
        return null;
    const config = { v: 1, backgroundRotation: ((Math.round(rotation) % 360) + 360) % 360 };
    for (const trait of options_1.AVATAR_TRAITS) {
        const value = source[trait];
        if (!isAllowedValue(trait, value))
            return null;
        config[trait] = value;
    }
    return config;
}
/**
 * A stored avatar brought up to the current options: a trait whose value this
 * build no longer offers, or a trait added since it was stored, takes the
 * fallback's value. Without this a profile stored by an older version could
 * never be saved again, because saving validates every trait.
 */
function normalizeAvatarConfig(stored, fallback) {
    const source = (stored && typeof stored === 'object' ? stored : {});
    const rotation = source.backgroundRotation;
    const config = {
        v: 1,
        backgroundRotation: typeof rotation === 'number' && Number.isFinite(rotation) ? rotation : fallback.backgroundRotation,
    };
    for (const trait of options_1.AVATAR_TRAITS) {
        const value = source[trait];
        config[trait] = isAllowedValue(trait, value) ? value : fallback[trait];
    }
    return config;
}
/** Format and reserved-name rules only; uniqueness and the bad-word filter are the server's. */
function nicknameFormatError(nickname) {
    if (nickname.length < options_1.NICKNAME_MIN_LENGTH || nickname.length > options_1.NICKNAME_MAX_LENGTH || !NICKNAME_PATTERN.test(nickname)) {
        return 'nickname-invalid';
    }
    const lower = nickname.toLowerCase();
    return RESERVED_FRAGMENTS.some(fragment => lower.includes(fragment)) ? 'nickname-reserved' : null;
}
